import React from 'react';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from "react-router-dom";
import firebase from "../firebase";
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import styled from 'styled-components'
// import * as firebaseui from 'firebaseui';
// import 'firebaseui/dist/firebaseui.css';
import { loadStripe } from '@stripe/stripe-js';
import { changeIsPaid, setNeedEmailVerify, setZlaboPremium } from '../actions/actions.js';
import "./upgrade.css";
import { CircularProgress } from '@material-ui/core';

const db = firebase.firestore();

// Make sure to call `loadStripe` outside of a component’s render    to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe('pk_live_v9nAtASHM2NMskW2FxrvzIiB00XwMEKMDt');
// const stripe = new Stripe('sk_test_HteEvBaCPAwOH7kjUkrSn6bI00B8bOi5y8')
// const Stripe = require('stripe')('sk_test_HteEvBaCPAwOH7kjUkrSn6bI00B8bOi5y8');
// const STRIPE_PUBLISHABLE_KEY = 'pk_test_k3Xdu3yzVNlKijN8TvOWvSs100z1Vt9ttd';

// Replace with your tax ids
// https://dashboard.stripe.com/tax-rates
const taxRates = ['txr_1ITjdBCqMbMZ2mlAie7lnYeH'];

const prices = {};

// Replace with your cloud functions location
const functionLocation = 'asia-northeast1';

const Background = styled.div`
background-color:  rgba(255,255,255,1);
width: 100%;
height: 100%;
position: absolute;
`;

const Wrapper = styled.div`
text-align: center;
margin-top: 200px;
`;

const Button = styled.button`
flex: 1;
margin: 2%;
border: none;
text-align: center;
display: inline-block;
background: #007DB3;
color: #fff;
text-decoration: none;
letter-spacing: .05em;
padding: 1%;
border-radius: 3px;
cursor: pointer;
box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%), 0 3px 1px -2px rgb(0 0 0 / 20%);
-webkit-tap-highlight-color: transparent;
transition: .3s ease-out;
`;

const Upgrade = () => {
  const isPaid = useSelector(state => state.user.isPaid);
  // const zlaboPremium = useSelector(state => state.user.isPaid);
  const [isSignedIn, setIsSignedIn] = useState(0);
  const [isLoading, switchLoading] = useState(false);
  const [zlaboPremium, setZlaboPremium] = useState(false);
  const [providerData, setProviderData] = useState(null);
  const needEmailVerify = useSelector(state => state.user.needEmailVerify);
  const dispatch = useDispatch();
  let history = useHistory();

  const firebaseUiConfig = {
    callbacks: {
      signInSuccessWithAuthResult: function (authResult, redirectUrl) {
        switchLoading(true);
        // User successfully signed in.
        // Return type determines whether we continue the redirect automatically
        // or whether we leave that to developer to handle.
        const user = authResult.user;

        if (!user.emailVerified) {
          user.sendEmailVerification()
            .then(() => {
              // Email verification sent!
              // ...
              switchLoading(false);
              alert("このメールアドレスに送信されたリンクをクリックし、本人確認を完了してください。")
            });
        }
        return false;
      },
    },
    signInFlow: 'popup',
    // signInSuccessUrl: '/アップグレード',
    signInOptions: [
      {
        provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
        requireDisplayName: false
      },
      {
        provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        clientId: '602433497528-jo0eqdbf9q0mhriclcg0lk6alapc7b15.apps.googleusercontent.com'
      },
      firebase.auth.FacebookAuthProvider.PROVIDER_ID,
    ],
    tosUrl: 'https://terms-213ad.web.app/',
    privacyPolicyUrl: 'https://privacypolicy-bb1c0.web.app/',
  };

  useEffect(() => {
    // console.log("useeffect on upgrade");
    const unregisterAuthObserver = firebase.auth().onAuthStateChanged(user => {
      if (user) {
        switchLoading(true);
        setIsSignedIn(1);
        const url = 'https://hooks.slack.com/services/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'
        const payload = {
          // slackのデータ
          "text": `${user.email}がログインしました。`
        }
        fetch(url, {
          method: 'POST',
          body: JSON.stringify(payload)
        }).then(function (responce) {
          if (!responce.ok) {
            alert('エラーです')
          }
        }).catch(function (error) {
          console.log(error.message)
        })

        setProviderData(user.providerData);
        // console.log("start data listener");

        db.collection('products')
          .where('active', '==', true)
          .get()
          .then(function (querySnapshot) {
            querySnapshot.forEach(async function (doc) {
              const priceSnap = await doc.ref
                .collection('prices')
                .where('active', '==', true)
                .where('interval', '==', 'month')
                .get();
              const product = doc.data();

              priceSnap.docs.forEach((doc) => {
                const priceId = doc.id;
                const priceData = doc.data();
                prices[priceId] = priceData;

                let interval;
                if (priceData.interval === 'month') {
                  interval = '月額';
                } else if (priceData.interval === 'year') {
                  interval = '年額';
                }
                const content =
                  `${interval} ${new Intl.NumberFormat('ja-JP', {
                    style: 'currency',
                    currency: priceData.currency,
                  }).format((priceData.unit_amount))}`;
                const option = document.createElement('option');
                option.value = priceId;
                option.innerHTML = content;
                // console.log("option: ", option);
                const price = document.querySelector("select");
                // console.log(price);
                if (price) {
                  price.appendChild(option);
                }
              });

              const form = document.getElementById('product-form');
              if (form) {
                form.addEventListener('submit', subscribe);
              }
            });
          });

        db.collection('customers')
          .doc(user.uid)
          .collection('subscriptions')
          .where('status', 'in', ['trialing', 'active'])
          .onSnapshot(async (snapshot) => {
            // console.log("zlaboPremium on upgrade get subscription: ", zlaboPremium);
            switchLoading(true);
            if (snapshot.empty) {
              dispatch(changeIsPaid(false));

              switchLoading(false);
              return;
            }

            dispatch(changeIsPaid(true));
            // console.log("zlaboPremium after changing isPaid", zlaboPremium);
            const subscription = snapshot.docs[0].data();
            const priceData = (await subscription.price.get()).data();
            let interval;
            if (priceData.interval === 'month') {
              interval = '月額';
            } else if (priceData.interval) {
              interval = '年額';
            }

            const mysubscription = document.getElementById("mysubscription");
            if (mysubscription) {
              mysubscription.innerHTML = `${interval} ${new Intl.NumberFormat('ja-JP', {
                style: 'currency',
                currency: priceData.currency,
              }).format(priceData.unit_amount)}を支払い中です。`;
            }
            db.collection('customers')
              .doc(user.uid)
              .onSnapshot(async (snapshot) => {
                await user.reload();
                // console.log("snapshot: ", snapshot.data());
                const zlabo_premium = !!snapshot.data().zlabo_premium;
                // console.log("zlabo_premium on upgrade: ", zlabo_premium);
                if (zlabo_premium && !user.emailVerified) {
                  // console.log("1 on upgrade");
                  setZlaboPremium(zlabo_premium);
                  dispatch(setNeedEmailVerify(true));
                  switchLoading(false);
                } else if (zlabo_premium && user.emailVerified) {
                  // console.log("2 on upgrade");
                  setZlaboPremium(zlabo_premium);
                  dispatch(setNeedEmailVerify(false));
                  switchLoading(false);
                } else if (!zlabo_premium) {
                  // console.log("3 on upgrade");
                  setZlaboPremium(!!snapshot.data().zlabo_premium);
                  dispatch(setNeedEmailVerify(false));
                  switchLoading(false);
                }
              });
            // console.log("zlaboPremium on upgrade end data listener: ", zlaboPremium);
          });
        // startDataListeners(user);
        // Checkout handler
        async function subscribe(event) {
          event.preventDefault();
          switchLoading(true);
          const user = firebase.auth().currentUser;
          if (user !== null) {
            await user.reload();
            const emailVerified = user.emailVerified;
            if (emailVerified || user.email === null) {
              const formData = new FormData(event.target);
              const selectedPrice = {
                price: formData.get('price'),
              };
              // For prices with metered billing we need to omit the quantity parameter.
              // For all other prices we set quantity to 1.
              if (prices[selectedPrice.price]?.recurring?.usage_type !== 'metered')
                selectedPrice.quantity = 1;

              const url = window.location.origin + "/%E3%82%A2%E3%83%83%E3%83%97%E3%82%B0%E3%83%AC%E3%83%BC%E3%83%89";
              const docRef = await db
                .collection('customers')
                .doc(user.uid)
                .collection('checkout_sessions')
                .add({
                  allow_promotion_codes: true,
                  billing_address_collection: "auto",
                  line_items: [selectedPrice],
                  success_url: url,
                  cancel_url: url,
                  metadata: {
                    key: 'value',
                  },
                });
              docRef.onSnapshot(async (snap) => {
                const { error, sessionId } = snap.data();
                if (error) {
                  alert(`An error occured: ${error.message}`);
                }
                if (sessionId) {
                  const stripe = await stripePromise;
                  const result = await stripe.redirectToCheckout({
                    sessionId: sessionId,
                  });
                  switchLoading(false);
                }
              });
            } else {
              alert("メールアドレスの確認が必要です。")
              switchLoading(false);
            }
          }
        }
      } else {
        setIsSignedIn(-1);
      }
    });
    return () => unregisterAuthObserver(); // Make sure we un-register Firebase observers when the component unmounts.
  }, []);

  /**
   * Data listeners
   */


  // Billing portal handler
  const billingPortalHandler = async (event) => {
    switchLoading(true);
    const url = window.location.origin + "/%E3%82%A2%E3%83%83%E3%83%97%E3%82%B0%E3%83%AC%E3%83%BC%E3%83%89";
    const functionRef = firebase
      .app()
      .functions(functionLocation)
      .httpsCallable('ext-firestore-stripe-subscriptions-createPortalLink');
    const { data } = await functionRef({ returnUrl: url });
    //console.log("data: ", data);
    window.open(data.url, "_blank");
    window.location.assign(data.url);
    switchLoading(false);
  };

  const Loading = () => {
    return (
      <Background>
        <Wrapper>
          <CircularProgress />
        </Wrapper>
      </Background>
    );
  }

  let ui;
  if (isSignedIn === -1) {
    ui = (
      <section style={{ position: "relative" }}>
        {isLoading && <Loading />}
        <>
          <div className="description">
            <p className="upg-title">アップグレード版追加機能</p>
            <p>アップグレード［月額550円］により、下記の全機能をご利用いただけます。</p>
            <ul style={{ paddingInlineStart: "30px" }}>
              <li>相続税計算・限界税率（相続人数変更）</li>
              <li>相続税の減少効果　　（相続人数変更）</li>
              <li>非課税枠の効果確認　（相続人数変更）</li>
              <li>退職金支給可能目安　（功績倍率変更）</li>
            </ul>
            <p style={{ color: "rgb(0, 125, 179)", fontWeight: "bold", textAlign: "center" }}>アップグレードにはアカウントが必要です。<br />新規登録も <span style={{ color: "#f44336" }}>[◯◯でログイン]</span>から可能です。</p>
            <br />
          </div>
          { }
          {/* <div id="firebaseui-auth-container"></div> */}
          <StyledFirebaseAuth uiConfig={firebaseUiConfig} firebaseAuth={firebase.auth()} />
        </>
      </section>
    );
  } else if (isSignedIn === 1) {
    if (isPaid) {
      if (zlaboPremium) {
        // console.log("rerender zlaboPremium:", zlaboPremium);
        ui = (
          <section style={{ position: "relative" }}>
            {isLoading && <Loading />}
            <main className="upg-container">
              {/* {console.log("isPaid on upgrade jsx: ", isPaid)}
          {console.log("zlaboPremium on upgrade jsx: ", zlaboPremium)} */}
              <section id="my-subscription">
                {!needEmailVerify && <p>お客様は機能をアップグレード済みです。</p>}

              </section>
              <br />
              <button className="simple-button" onClick={() => history.push("アカウント")} >アカウント</button>
              <br />
              {needEmailVerify && <p>アップグレード版機能の開放にはメールアドレスの確認が必要です。<br />登録メールアドレスに送信されたURLを開いてください。<br /><br />ゼットラボプレミアム会員様特典として無料でご利用いただけます。</p>}
              {!needEmailVerify && <p style={{ color: "#ec6941" }}>ゼットラボプレミアム会員様特典として無料でご利用いただいております。<br /><br />ゼットラボプレミアム会員を退会されると本アプリの特典も停止されます。ご了承ください。</p>}
            </main>
          </section>);
      } else {
        ui = (
          <section style={{ position: "relative" }}>
            {isLoading && <Loading />}
            <main className="upg-container">
              {/* {console.log("isPaid on upgrade jsx: ", isPaid)}
          {console.log("zlaboPremium on upgrade jsx: ", zlaboPremium)} */}
              <section id="my-subscription">
                <p>お客様は機能をアップグレード済みです。</p>
                <><p id="mysubscription"></p>
                  <Button className="billing-portalhandler" onClick={() => billingPortalHandler()}>支払いの確認</Button></>
              </section>
              <br />
              <button className="simple-button" onClick={() => history.push("アカウント")} >アカウント</button>
              <br />
            </main>
          </section>);
      }

    } else {
      ui = (
        <section style={{ position: "relative" }}>
          {isLoading && <Loading />}
          <main className="upg-container">
            <div id="subscribe">
              <section className="products">
                <div className="product">
                  <div className="description">
                    <p className="upg-title">アップグレード版追加機能</p>
                    <ul>下記ツールの相続人数の変更機能
                      <li>相続税計算・限界税率</li>
                      <li>相続税の減少効果</li>
                      <li>非課税枠の効果</li>
                    </ul>
                    <ul>下記ツールの功績倍率変更機能
                      <li>退職金支給可能目安</li>
                    </ul>
                  </div>
                  <form id="product-form">
                    <div className="form-container">
                      <select id="price" name="price" className="form-item"></select>
                      <button className="upgrade-button form-item" type="submit">アップグレード</button>
                    </div>
                  </form>
                </div>
                <br />
                <button className="simple-button" onClick={() => history.push("アカウント")} >アカウント</button>
                <br />
              </section>
            </div>
          </main>
        </section>)
    }

  } else if (isSignedIn === 0) {
    ui = (
      <section style={{ position: "relative" }}>
        <Loading />
      </section>
    );
  }
  return ui;
}

export default Upgrade;